import { create } from 'zustand';
import {
  type ColorMode,
  applyColorModeToDocument,
  readStoredColorMode,
  resolveColorMode,
  writeStoredColorMode,
} from './themeMode';

interface ThemeState {
  /** null = follow OS until user toggles */
  storedMode: ColorMode | null;
  resolvedMode: ColorMode;
  setColorMode: (mode: ColorMode) => void;
  toggleColorMode: () => void;
  syncFromStorage: () => void;
}

function computeResolved(storedMode: ColorMode | null): ColorMode {
  return resolveColorMode(storedMode);
}

const initialStored = readStoredColorMode();
const initialResolved = computeResolved(initialStored);

applyColorModeToDocument(initialResolved);

export const useThemeStore = create<ThemeState>((set, get) => ({
  storedMode: initialStored,
  resolvedMode: initialResolved,
  setColorMode: (mode: ColorMode) => {
    writeStoredColorMode(mode);
    applyColorModeToDocument(mode);
    set({ storedMode: mode, resolvedMode: mode });
  },
  toggleColorMode: () => {
    const next: ColorMode = get().resolvedMode === 'dark' ? 'light' : 'dark';
    get().setColorMode(next);
  },
  syncFromStorage: () => {
    const storedMode = readStoredColorMode();
    const resolvedMode = computeResolved(storedMode);
    applyColorModeToDocument(resolvedMode);
    set({ storedMode, resolvedMode });
  },
}));
